"use client";
import Tabs from "@components/common/Tab";
import styles from "./TabInformation.module.scss";
import cx from "classnames";
import { get } from "lodash";
import { usePageContext } from "@providers/PageProvider";
import Markdown from "@components/common/Markdown";
const View = () => {
  const { pageData } = usePageContext();
  const general = get(pageData, "general");
  const specification = get(pageData, "specification");
  const items: any = [
    {
      key: "description",
      label: "Mô Tả",
      children: <Markdown className={styles.description} content={general} />,
    },
    {
      key: "specification",
      label: "Thông Số Kỹ Thuật",
      children: (
        <div
          className={styles.specification}
          dangerouslySetInnerHTML={{ __html: specification }}
        ></div>
      ),
    },
  ];

  return (
    <section data-scroll-section className={cx(styles.section)}>
      <div className="inner-product">
        <Tabs defaultActiveKey="description" items={items} />
      </div>
    </section>
  );
};
export default View;
